const MODULE_NAME = 'USER'

export const SET_UUID = `${MODULE_NAME}/SET_UUID`
export const GET_STATUS = `${MODULE_NAME}/GET_STATUS`
export const SET_STATUS = `${MODULE_NAME}/SET_STATUS`
export const SEND_FACEBOOK_PARAMS = `${MODULE_NAME}/SEND_FACEBOOK_PARAMS`
export const SEND_USER_ANSWERS = `${MODULE_NAME}/SEND_USER_ANSWERS`
export const SEND_USER_EMAIL = `${MODULE_NAME}/SEND_USER_EMAIL`
export const SEND_USER_CONFIG = `${MODULE_NAME}/SEND_USER_CONFIG`
export const SET_UTM_TAGS = `${MODULE_NAME}/SET_UTM_TAGS`
export const UPDATE_USER_CONFIG = `${MODULE_NAME}/UPDATE_USER_CONFIG`
export const SAVE_PLAN_ADDITIONS = `${MODULE_NAME}/SAVE_PLAN_ADDITIONS`
export const GET_USER_ACCOUNT_STATUS = `${MODULE_NAME}/GET_ACCOUNT_STATUS`
export const SET_USER_ACCOUNT_STATUS = `${MODULE_NAME}/SET_ACCOUNT_STATUS`
export const RESEND_USER_INSTRUCTIONS = `${MODULE_NAME}/RESEND_INSTRUCTIONS`
export const BIND_USER = `${MODULE_NAME}/BIND_USER`
